import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const safeJsonParse = (value, fallback = null) => {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const normalizeRole = (r) =>
  typeof r === "string" ? r.trim().toLowerCase() : null;

const ProtectedRoute = ({ role }) => {
  const location = useLocation();

  // ✅ Prefer ONE object: auth = { token, role }
  const auth = safeJsonParse(localStorage.getItem("auth"), {}) || {};

  let token = auth?.token || localStorage.getItem("token") || null;
  let userRole = auth?.role || localStorage.getItem("role") || null;

  userRole = normalizeRole(userRole);
  const requiredRole = normalizeRole(role);

  // console.log("🔹 ProtectedRoute check:", {
  //   hasToken: !!token,
  //   userRole: userRole || "none",
  //   requiredRole: requiredRole || "none",
  // });

  // ✅ 1) Must be logged in
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // ✅ 2) If role is required, validate it
  if (requiredRole) {
    if (!userRole) return <Navigate to="/unauthorized" replace />;
    if (userRole !== requiredRole) return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;